import React, { useState } from "react";

import { ITimeProps } from "components/dashboard/product-template-table/utils/interfaces";
import { Calendar } from "primereact/calendar";
import { FormEvent } from "primereact/ts-helpers";
import { convert, LocalDate, LocalTime } from "@js-joda/core";

export default function Time(props: ITimeProps) {
  const [time, setTime] = useState<Date | undefined>(strTimeAsNativeDate(props.value));

  const handleChangeEvent = (val: FormEvent<Date, React.SyntheticEvent<Element, Event>>) => {
    const timeVal = val.value as Date | undefined;
    if (timeVal) {
      setTime(timeVal);
      const changedVal = `${String(timeVal?.getHours()).padStart(2, "0")}:${String(timeVal?.getMinutes()).padStart(2, "0")}`;
      props.changeHandler(changedVal);
    } else {
      setTime(undefined);
      props.changeHandler("-");
    }
  };

  if (props.isInEditMode) {
    return (
      <div>
        <Calendar
          value={time}
          onChange={handleChangeEvent}
          placeholder="Time not set"
          className="w-full"
          timeOnly
          stepMinute={1}
        />
      </div>
    );
  }
  return (
    <div
      className="p-inputtext"
      style={{
        padding: "auto",
        border: "none",
        backgroundColor: "transparent",
        color: "inherit",
        whiteSpace: "nowrap",
      }}
    >
      {props.value ? props.value : "-"}
    </div>
  );
}

const strTimeAsNativeDate = (strTime: string) => {
  try {
    const date = LocalTime.parse(strTime).atDate(LocalDate.now());
    return convert(date).toDate();
  } catch (e) {
    return undefined;
  }
};
